import { standartPost as post } from '@namespace/helpers';
import { apiRoutes } from './apiRoutes';

export const getBalance = () =>
  post(apiRoutes.getBalance(), {}).then(({ data }) => data);

export const topUpBalance = (data) => post(apiRoutes.topUpBalance(), data);

export const withdraw = (data) => post(apiRoutes.withdraw(), data);
